import Component from "@ember/component"
import { computed, get } from "@ember/object"
import type { CardStack } from "@shared/models/card-stack"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import { sortBy } from "lodash-es"

export default class MonthRoutineComponent extends Component {
  // Args
  routine!: CardStack
  planbook!: Planbook
  rotationCalendar!: RotationCalendar
  dateString!: string
  hiddenCourseIds!: Array<string>

  // CPs & Relationships
  @computed("routine.attributes.cards", "routine.attributes._revision")
  get sortedCards() {
    let cards = get(get(get(this, "routine"), "attributes"), "cards")
    return sortBy(cards, (card) => {
      return card.attributes.position
    })
  }
}
